import { render, staticRenderFns } from "./CrearPersonaDesdeDeudaPage.vue?vue&type=template&id=5bbf4d70&scoped=true"
import script from "./CrearPersonaDesdeDeudaPage.vue?vue&type=script&lang=js"
export * from "./CrearPersonaDesdeDeudaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf4d70",
  null
  
)

export default component.exports